import axios from "axios";

export const uploadFile = async (data) => {
  const file = await axios.get(
    `${process.env.REACT_APP_BASE_URL_UPLOAD}?fileName=${data.name}&contentType=${data.type}`
  );

  var config = {
    method: "put",
    url: file.data.fileUploadURL,
    headers: {
      "Content-Type": data.type,
    },
    data: data.file,
  };

  const upload = await axios(config);
  return upload;
};

export const downloadFile = async (data) => {
  const file = await axios.get(
    `${process.env.REACT_APP_BASE_URL_UPLOAD}?fileName=${data.name}&bucket=${data.bucket}`
  );
  return file.data.fileUploadURL;
};
